export const groupAndSum = (data, groupFields, sumFields) => {
  const map = new Map();

  data.forEach((item) => {
    // Create a composite key from all group fields
    const key = groupFields.map((field) => item[field]).join("|");

    if (!map.has(key)) {
      // Initialize with grouping fields + zeroed sum fields
      const base = {};
      groupFields.forEach((field) => (base[field] = item[field]));
      sumFields.forEach((field) => (base[field] = 0));
      map.set(key, base);
    }

    // Add current values to sums
    const aggregated = map.get(key);
    sumFields.forEach((field) => {
      aggregated[field] += Number(item[field]) || 0;
    });
  });

  return Array.from(map.values());
};
export const generateUniqueId = () => {
  // Generate a random component
  const randomPart = Math.random().toString(36).substr(2, 5);

  // Get the current timestamp
  const timestampPart = new Date().getTime().toString(36);

  // Combine the random and timestamp parts
  const uniqueId = `${timestampPart}-${randomPart}`;

  return uniqueId;
};
export const generateUniqueOrderNum = () => {
  // Generate a random component
  const randomPart = Math.random(new Date().getTime())
    .toString(10)
    .substring(2, 7);

  // Get the current timestamp
  const timestampPart = new Date().getTime().toString(10).substring(7, 11);

  // Combine the random and timestamp parts
  const uniqueId = `${timestampPart}${randomPart}`;

  return uniqueId;
};
export const getGraphFromDataPoints = (dataPoints1, graphName) => {
  let proportionedPoints = [];
  const max = Math.max(...dataPoints1.map((p) => p.value));
  const min = Math.min(...dataPoints1.map((p) => p.value));
  const diff = max - min;
  // console.log("min max", min, max);
  dataPoints1.forEach((p, i) => {
    let newPointObject = { value: 1 };

    // console.log("p.value", p.value);
    newPointObject = { value: ((p.value - min) * 4) / diff + 1 };
    if (p.value == max) {
      newPointObject = { value: 5 };
    }
    if (p.value == min) {
      newPointObject = { value: 1 };
    }

    proportionedPoints = proportionedPoints.concat(newPointObject);
    // proportionedPoints = proportionedPoints.concat({
    //   ...newPointObject,
    //   realVal: p,
    // });
  });
  // console.log("proportionedPoints", proportionedPoints);

  var numberOfPoints = dataPoints1.length;
  var totalWidth = numberOfPoints * 35;

  const myGraphData = {
    name: graphName,
    originalPoints: dataPoints1,
    data: proportionedPoints,
    maxValue: 5,
    noOfSections: numberOfPoints,
    height: 50,
    width: totalWidth,
    // adjustToWidth: true,
    spacing: totalWidth / numberOfPoints,
    initialSpacing: 5,
  };
  return myGraphData;
};
export const formatDate = (date = new Date()) => {
  const year = date.toLocaleString("default", { year: "numeric" });
  const month = date.toLocaleString("default", {
    month: "2-digit",
  });
  const day = date.toLocaleString("default", { day: "2-digit" });

  return [year, month, day].join("-");
};
export const addDaysToDate = (date, days) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};
export function compareDates(stringDate1, stringDate2) {
  return new Date(stringDate1).getTime() >= new Date(stringDate2).getTime();
}
export function sortByEarningsDate(arr) {
  const parseDate = (d) => {
    if (!d) return null; // empty or undefined
    const date = new Date(d);
    return isNaN(date.getTime()) ? null : date; // return null if invalid
  };

  return arr.sort((a, b) => {
    const dateA = parseDate(a.earningsDate);
    const dateB = parseDate(b.earningsDate);

    if (!dateA && !dateB) return 0; // both invalid
    if (!dateA) return 1; // invalid goes to end
    if (!dateB) return -1; // invalid goes to end

    return dateA - dateB; // ascending (closest first)
  });
}
